import { API_BASE_URL } from "../api/config";

export const API_URL = API_BASE_URL;

export default API_URL;
